import { BASE_URL } from "../App";
import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import axios from 'axios';
import Swal from 'sweetalert2';
import { Card } from 'antd';
import { Button, Backdrop, CircularProgress, FormControlLabel, TextField, Radio, RadioGroup, Dialog, DialogTitle, DialogContent, DialogActions, Chip } from '@mui/material';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import RemoveRedEyeRoundedIcon from '@mui/icons-material/RemoveRedEyeRounded';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';


export default function ForgetPassword() {

    const navigate = useNavigate();
    const location = useLocation();
    const Input_Login_ID = location.state && location.state.Input_Login_ID;

    const [open, setOpen] = React.useState(false);
    const [LoginID, setLoginID] = useState({ LoginId: Input_Login_ID });
    const [DealerDetails, setDealerDetails] = useState({ MobileNo: '', Name: '', LedgerCode: '' });
    const [EnteredOTP, setEnteredOTP] = useState('');

    const [SmsSend, setSmsSend] = useState(false);
    const [OtpValidate, setOtpValidate] = useState(false);




    const ValidateLoginID = () => {
        setOpen(true);

        if (!LoginID.LoginId) {
            Swal.fire({
                icon: "warning",
                text: 'Please Enter Login ID.!'
            });
            setOpen(false);
            return false;
        }

        const data = { Type: 'LoginIDValidate', LOGIN_ID: LoginID.LoginId }

        axios.post(BASE_URL + '/ForgetPassword', data)
            .then(response => {
                if (response.status === 200) {
                    setSmsSend(true);
                    const DealerData = response.data.message;
                    setDealerDetails({
                        MobileNo: DealerData.Mobile_number,
                        Name: DealerData.Name,
                        LedgerCode: DealerData.Sales_Ledger_Code,
                    });
                } else {
                    Swal.fire({
                        icon: "warning",
                        text: response.data.message
                    });
                }
            })
            .catch(error => {
                if (error.response) {
                    Swal.fire({
                        icon: "warning",
                        text: error.response.data.message
                    });
                }
            }).finally(() => {
                setOpen(false);
            });
    }

    const maskMobileNo = (mobileNo) => {
        if (mobileNo && mobileNo.length >= 2) {
            const lastTwoDigits = mobileNo.slice(-3);
            const maskedNumber = '*******' + lastTwoDigits;
            return maskedNumber;
        } else {
            return mobileNo;
        }
    };

    const SendOtp = () => {
        setOpen(true);

        const data = {
            Type: 'OtpSend',
            LOGIN_ID: LoginID.LoginId,
            MobileNo: DealerDetails.MobileNo,
            Name: DealerDetails.Name
        }

        axios.post(BASE_URL + '/ForgetPassword', data)
            .then(response => {
                if (response.status === 200) {
                    Swal.fire({
                        icon: "success",
                        text: response.data.message
                    });
                    setOtpValidate(true);
                    setSmsSend(false);
                } else {
                    Swal.fire({
                        icon: "warning",
                        text: response.data.message
                    });
                }
            })
            .catch(error => {
                if (error.response) {
                    Swal.fire({
                        icon: "warning",
                        text: error.response.data.message
                    });
                }
            }).finally(() => {
                setOpen(false);
            });
    }

    const VerifyOTP = () => {
        setOpen(true);

        const data = {
            Type: 'VerifyOTP',
            LOGIN_ID: LoginID.LoginId,
            MobileNo: DealerDetails.MobileNo,
            Name: DealerDetails.Name,
            OTP: EnteredOTP
        }

        axios.post(BASE_URL + '/ForgetPassword', data)
            .then(response => {
                if (response.status === 200) {
                    navigate('/Reset_Password', {
                        state: {
                            LOGIN_ID: LoginID.LoginId,
                            NAME: DealerDetails.Name,
                        }
                    });
                } else {
                    Swal.fire({
                        icon: "warning",
                        text: response.data.message
                    });
                }
            })
            .catch(error => {
                if (error.response) {
                    Swal.fire({
                        icon: "warning",
                        text: error.response.data.message
                    });
                }
            }).finally(() => {
                setOpen(false);
            });
    }

    return (
        <>
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <div className="container mt-5">
                <div className="card1">
                    <center><h3 style={{ fontWeight: '1000' }}><i>Forgot Password</i></h3></center>
                    <hr />
                    <div className="row">
                        <div className="col">
                            <TextField
                                label="Login ID"
                                size="small"
                                fullWidth
                                className="mb-3"
                                value={LoginID.LoginId}
                                onChange={(e) => {
                                    const input = e.target.value;
                                    const truncatedInput = input.slice(0, 15);
                                    setLoginID({ ...LoginID, LoginId: truncatedInput });
                                }}
                            />
                        </div>
                        <div className="col">
                            <Button
                                fullWidth
                                variant="contained"
                                className="mb-3"
                                onClick={ValidateLoginID}
                            >
                                <b>Validate Login ID</b>
                            </Button>
                        </div>
                    </div>

                    {SmsSend && (
                        <>
                            <span>Get a verification code by text message at: <b>{maskMobileNo(DealerDetails.MobileNo)}</b></span>
                            <br />
                            <Button fullWidth variant="contained" className="mt-2" onClick={SendOtp}><b>Send Verification Code</b></Button>
                        </>
                    )}

                    {OtpValidate && (
                        <>
                            <TextField
                                label="Enter OTP "
                                size="small"
                                fullWidth
                                className="mb-3"
                                value={EnteredOTP}
                                onChange={(e) => {
                                    const input = e.target.value;
                                    const numbersOnly = input.replace(/\D/g, '');
                                    const truncatedInput = numbersOnly.slice(0, 5);
                                    setEnteredOTP(truncatedInput);
                                }}
                            />
                            <br />
                            <Button fullWidth variant="contained" className="mt-2" onClick={VerifyOTP}><b>Verify OTP</b></Button>
                        </>
                    )}

                    <br />
                    <br />
                    <br />
                    <center>
                        <Chip
                            icon={<KeyboardBackspaceIcon />}
                            onClick={() => navigate('/')}
                            label={"Back To Login"}
                            variant="filled"
                            sx={{
                                background: '#1976d2',
                                color: '#fff',
                                fontWeight: 'bold',
                                fontSize: '1rem',
                                padding: '10px 20px',
                                borderRadius: '12px',
                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                '& .MuiChip-icon': {
                                    color: '#fff',
                                },
                            }}
                        />
                    </center>
                </div>
            </div>
        </>
    );
}